































import { Component, Vue } from "vue-property-decorator";
import EmailForm from '../contact/EmailForm.vue';

@Component({
  components: {
    EmailForm,
  },
})
export default class TravelAlternativeLink extends Vue {

  get getChBxColor(): boolean {
        return this.$store.getters.getCheckboxLabelColor;
      }

  get getIsShowEmailFormActive() {
    return this.$store.getters.getEmailModalCondition;
  }

  showEmailForm(): void {
    this.$store.dispatch('setEmailModalCondition', true);
  }

  getConsultation(): void {
    this.$storage.actions.setModal({
      name: "ModalConsultation",
      from: "alt",
    });
  }

  getCustomPlan(): void {
    this.$storage.actions.setModal({
      name: "ModalPlan",
      from: "alt",
    });
  }
}
